import React from "react";
import { offerKey, offerTerms } from "../lib/storeOffers";

export default function StoreOfferPicker({ offers, selected, onChange, disabled }) {
  const terms = offerTerms(selected);
  return <div className="text-xs text-white/60 mt-2">
    {offers?.length > 1 && <select aria-label="Offre et durée de l’abonnement" value={selected ? offerKey(selected) : ""}
      disabled={disabled} onChange={(event) => onChange(event.target.value)} className="w-full bg-black border border-white/20 rounded p-2 mb-2">
      {offers.map((offer) => <option key={offerKey(offer)} value={offerKey(offer)}>{offerTerms(offer).description}</option>)}
    </select>}
    {terms && <p>{terms.description}</p>}
  </div>;
}
